export default function CodetagIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 16}
      height={height ? height : width ? width : 16}
      viewBox="0 0 15 11.985"
    >
      <g fill="currentColor" transform="translate(-603 -195.6)">
        <path d="M612.861 207.585a.726.726 0 1 1 0-1.453h1.217a.932.932 0 0 0 .962-.962v-1.58a1.9 1.9 0 0 1 .409-1.2 2.083 2.083 0 0 1 1.044-.726v-.144a1.961 1.961 0 0 1-1.043-.72 1.941 1.941 0 0 1-.41-1.2v-1.585a.932.932 0 0 0-.962-.962h-1.217a.726.726 0 1 1 0-1.453h1.507a2.108 2.108 0 0 1 2.125 2.125v1.634a.952.952 0 0 0 .263.69.883.883 0 0 0 .663.272.537.537 0 0 1 .418.182.629.629 0 0 1 .163.436v1.308a.629.629 0 0 1-.163.436.537.537 0 0 1-.418.182.883.883 0 0 0-.663.272.952.952 0 0 0-.263.69v1.634a2.108 2.108 0 0 1-2.125 2.125Zm-6.229 0a2.108 2.108 0 0 1-2.125-2.125v-1.634a.952.952 0 0 0-.263-.69.883.883 0 0 0-.663-.272.545.545 0 0 1-.409-.182.61.61 0 0 1-.173-.436v-1.307a.61.61 0 0 1 .173-.436.545.545 0 0 1 .409-.182.883.883 0 0 0 .663-.272.952.952 0 0 0 .263-.69v-1.634a2.108 2.108 0 0 1 2.125-2.125h1.507a.726.726 0 1 1 0 1.453h-1.216a.932.932 0 0 0-.962.962v1.585a1.941 1.941 0 0 1-.411 1.2 1.961 1.961 0 0 1-1.044.717v.145a2.083 2.083 0 0 1 1.044.726 1.9 1.9 0 0 1 .409 1.2v1.58a.932.932 0 0 0 .962.962h1.218a.726.726 0 1 1 0 1.453Z" />
        <circle
          cx="1.769"
          cy="1.769"
          r="1.769"
          transform="translate(608.731 199.823)"
        />
      </g>
    </svg>
  );
}
